<button
  [ngClass]="{ highlight: (rightSidebarOpen$ | async) }"
  mat-icon-button
  [matTooltip]="'TOGGLE_RIGHT_SIDEBAR' | transloco"
  (click)="onClickToggleRightSidebar()"
>
  <mat-icon>view_sidebar</mat-icon>
</button>
